type Parameters = {
  name: string;
  urlAlias: string;
};

export const getVideoSectionTitleFromUrlAlias = ({ name, urlAlias }: Parameters) => {
  const subDirectories = urlAlias.split("/");

  const subDirectoriesWithoutLast = subDirectories.slice(0, -1);

  const capitalizedSubDirectories = subDirectoriesWithoutLast.map(subDirectory => {
    if (subDirectory.length === 0) {
      return subDirectory;
    }

    const sections = subDirectory.split("-");
    const capitalizedSections = sections.map(section => {
      if (section.length === 0) {
        return section;
      }

      return section.charAt(0).toUpperCase() + section.slice(1);
    });

    return capitalizedSections.join(" ");
  });

  const capitalizedName = name
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return [...capitalizedSubDirectories.slice(1), capitalizedName].join(" / ");
};
